// src/pages/admin/AdminLayout.tsx

import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import AdminSidebar from '../../components/admin/AdminSidebar'

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="flex h-screen overflow-hidden bg-[#fdf8f0]">

      {/* 데스크탑: 항상 보이는 사이드바 */}
      <div className="hidden md:flex shrink-0">
        <AdminSidebar />
      </div>

      {/* 모바일: 슬라이드 오버레이 사이드바 */}
      <div className="md:hidden">
        {/* 배경 딤 */}
        <div
          className={`fixed inset-0 bg-black/40 z-[200] transition-opacity duration-300 ${sidebarOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
          onClick={() => setSidebarOpen(false)}
        />
        {/* 사이드바 패널 */}
        <div
          className={`fixed top-0 left-0 h-full z-[201] transition-transform duration-300 ease-in-out ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}`}
        >
          <AdminSidebar onClose={() => setSidebarOpen(false)} />
        </div>
      </div>

      {/* 콘텐츠 영역 */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        {/* 모바일 상단 헤더 */}
        <div className="md:hidden flex items-center px-4 py-3 bg-white border-b border-gray-100 shadow-sm">
          <button
            onClick={() => setSidebarOpen(true)}
            className="bg-transparent border-none cursor-pointer p-1 text-[#2a1f1a]"
          >
            <svg viewBox="0 0 24 24" width={24} height={24} fill="none" stroke="currentColor" strokeWidth={2}>
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
          <span className="ml-3 font-bold text-[#2a1f1a]">마루빛 관리자</span>
        </div>

        <div className="flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </div>

    </div>
  )
}
